import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-wizard', 'completedStep', 'Completed step');
Labels.set('ui-wizard', 'next', 'Next');
Labels.set('ui-wizard', 'back', 'Back');
